var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fkefu"},[_c('img',{attrs:{"src":"https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/imgs/kefu.png","alt":""}}),_c('div',{staticClass:"ghome",on:{"click":_vm.gohome}},[_vm._v("返回上一页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }